/* eslint-disable max-statements */
/* eslint-disable complexity */
import md5 from 'blueimp-md5';
import { addClass, removeClass } from './utils';
import { apiClient } from './embedOptionsApiClient';

export default class EmbedOptions {
  constructor(props) {
    this.formID = props.formID;
    this.layout = props;
    this.inlineEmbed = false;
    this.layout = 'standard';
    this.listenEmbedOptionsMessage = this.listenEmbedOptionsMessage.bind(this);
    this.initializeStandardProgress = this.initializeStandardProgress.bind(this);
    this.initializeModernProgress = this.initializeModernProgress.bind(this);
    this.calculateFormHeight = this.calculateFormHeight.bind(this);
    this.handleQuestionChange = this.handleQuestionChange.bind(this);
    this.calculateWelcomeSize = props.calculateWelcomeSize;
    this.styleJSON = {};
    this.embedStyleJSON = {};

    const isEmbed = global.parent !== global;
    if (isEmbed) {
      // this.populateEmbedOptionsButton();
      this.bindIframeMessageListener();
      this.handleQuestionChange();
    }
  }

  bindIframeMessageListener() {
    if (window.addEventListener) {
      window.addEventListener('message', this.listenEmbedOptionsMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', this.listenEmbedOptionsMessage);
    }
  }

  handleOptionsButtonClick() {
    this.togglePanelStatus();
  }

  togglePanelStatus() {
    this.sendPostMessage({ type: 'toggleInlineEmbedPanel' });
  }

  sendPostMessage(data) {
    window.parent.postMessage(JSON.stringify(data), '*');
  }

  populateEmbedOptionsButton() {
    const isEmbed = global.parent !== global;
    if (isEmbed) {
      const optionsButton = document.createElement('img');
      optionsButton.classList.add('embedOptionsButton');
      optionsButton.src = 'https://cdn.jotfor.ms/assets/img/cardforms/pencil.svg';
      optionsButton.setStyle({
        position: 'absolute',
        top: '20px',
        left: '20px',
        width: '40px',
        cursor: 'pointer',
        zIndex: '1'
      });

      optionsButton.addEventListener('click', () => {
        this.handleOptionsButtonClick();
      });

      document.body.appendChild(optionsButton);

      const tooltip = document.createElement('div');
      tooltip.classList.add('toolTip');
      tooltip.classList.add('u-neutral');
      tooltip.classList.add('u-northWest');
      tooltip.classList.add('u-tethered');
      tooltip.setStyle({ display: 'none', visibility: 'initial', textAlign: 'center', top: '62px', left: '20px', width: '240px', borderRadius: '3px', fontSize: '13px', opacity: 'initial' });

      tooltip.innerHTML = 'Only Form owner see this button';
      const tooltipSpan = document.createElement('span');
      tooltipSpan.setStyle({ display: 'block', fontSize: '10px' });
      tooltipSpan.innerHTML = 'Inline Embed Feature by <a style="color: orange; text-decoration: none" href="https://jotform.com" target="_blank">Jotform</a>';

      tooltip.appendChild(tooltipSpan);

      optionsButton.addEventListener('mouseenter', () => {
        tooltip.style.display = 'block';
      });

      optionsButton.addEventListener('mouseleave', () => {
        tooltip.style.display = 'none';
      });

      document.body.appendChild(tooltip);

      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', 'https://moodular.jotform.com/dist/moodular4/tooltips.css');
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(link);
    }
  }

  addStyle(elements, styles) {
    if (elements instanceof NodeList || elements instanceof HTMLCollection || Array.isArray(elements)) {
      elements.forEach(element => this.applyStyles(element, styles));
    } else if (elements instanceof Element) {
      this.applyStyles(elements, styles);
    }
  }

  addStyleWithTag(tagId, styleText) {
    var style = document.querySelector(`#${tagId}`);

    if (!style) {
      style = document.createElement('style');
      style.type = 'text/css';
      style.id = tagId;
      document.head.appendChild(style);
    }

    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(styleText);
  }

  applyStyles(element, styles) {
    if (typeof element.setStyle === 'function') {
      element.setStyle(styles);
    } else {
      for (const cssRule in styles) {
        if (styles.hasOwnProperty(cssRule)) {
          element.style[cssRule] = styles[cssRule];
        }
      }
    }
  }

  listenEmbedOptionsMessage(opts) {
    // To prevent empty data error
    if (!opts.data) return;

    try {
      const isEmbedButton = opts.data.split(':')[0];
      if (isEmbedButton === 'embedOptions') {
        return;
      }
      const data = JSON.parse(opts.data);

      if (data.showOwnerButton) this.populateEmbedOptionsButton();

      if (data.styleJSON) {
        this.styleJSON = data.styleJSON;
      }
      if (data.embedStyleJSON) {
        this.embedStyleJSON = data.embedStyleJSON;
      }

      if (data.beginBackgroundColor) {
        this.addStyle(document.querySelector('.jfForm-wrapper'), { background: data.beginBackgroundColor });
        this.addStyle(document.querySelector('.jfForm-backgroundContainer'), { background: data.beginBackgroundColor });
        this.addStyle(document.querySelector('.jotform-form'), { background: data.beginBackgroundColor });
        this.addStyle(document.querySelector('.jfProgress'), { background: data.beginBackgroundColor });
      }

      if(data.formBackgroundImage){
        this.addStyle(document.querySelector('.jfForm-backgroundContainer'), { 'background-image': `url('${data.formBackgroundImage}')` });
      }

      if (data.buttonBackgroundColor) {
        this.addStyle(document.querySelectorAll('.jfCard-actions'), { background: data.buttonBackgroundColor });
        this.addStyle(document.querySelectorAll('.jfWelcome-button'), { background: data.buttonBackgroundColor });
      }

      if (data.buttonTextColor) {
        this.addStyle(document.querySelectorAll('.jfInput-button'), { color: data.buttonTextColor });
        this.addStyle(document.querySelectorAll('.jfWelcome-button'), { color: data.buttonTextColor });
        const svgStyle = document.createTextNode(`
        .cf-minimal .jfWelcome-button:not(.forPrev-heading):not(.forNext-hading):after, .cf-minimal .jfInput-button:not(.forMobileNav).forNext:after{
          background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16'%3e%3cg fill='none' fill-rule='evenodd' stroke='%23${data.buttonTextColor.substring(1)}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3e%3cpath d='M1.7797 8.0199h20.9252l-6.2016 6.2016'/%3e%3cpath d='M16.806 1.308l5.8236 6.5842-2.9118 3.0499'/%3e%3c/g%3e%3c/svg%3e")
        }
        .cf-minimal .jfInput-button:not(.forMobileNav).forPrev:before, .cf-minimal .jfInput-button:not(.forMobileNav).forPrev-heading:before, .cf-minimal .jfInput-button:not(.forMobileNav).forBackToForm:before{
          background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16'%3e%3cg fill='none' fill-rule='evenodd' stroke='%23${data.buttonTextColor.substring(1)}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'%3e%3cpath d='M22.2203 8.0199H1.2951l6.2016 6.2016'/%3e%3cpath d='M7.194 1.308L1.3704 7.8922l2.9118 3.0499'/%3e%3c/g%3e%3c/svg%3e")
         }
        `);
        this.addStyleWithTag('button-text', svgStyle);
      }

      if (data.sectionBackgroundColor) {
        this.addStyle(document.querySelector('.jfForm-background-mask'), { background: data.sectionBackgroundColor });
      }

      if (data.sectionTextColor) {
        this.addStyle(document.querySelector('.jfWelcome-sectionInfo'), { color: data.sectionTextColor });
        this.addStyle(document.querySelector('.jfWelcome-header'), { color: data.sectionTextColor });
        this.addStyle(document.querySelectorAll('.jfWelcome-header, .jfWelcome-description'), { color: data.sectionTextColor });
        this.addStyle(document.querySelectorAll('.jfWelcome-image svg path, .jfForm-logo svg path'), { fill: data.sectionTextColor });
      }

      if (data.cardBorderColor) {
        this.addStyle(document.querySelectorAll('.jfCard'), { border: `1px solid ${data.cardBorderColor}` });
      }

      if (data.nextButtonColor) {
        this.addStyle(document.querySelectorAll('.jfInput-button.forNext'), { background: data.nextButtonColor, 'border-color': data.nextButtonColor });
        document.querySelectorAll('.jfProgress-item').forEach((item) => {
          item.setAttribute('data-color', data.nextButtonColor);
        });
      }

      if (data.prevButtonColor) {
        this.addStyle(document.querySelectorAll('.jfInput-button.forPrev'), { background: data.prevButtonColor, 'border-color': data.prevButtonColor });
      }

      if (data.overviewColor) {
        this.addStyle(document.querySelector('.jfProgress-infoContent'), { background: data.overviewColor });
      }

      if (data.progressBackground) {
        this.addStyle(document.querySelector('.jfProgress-itemWrapper'), { background: data.progressBackground });
      }

      if (data.overviewTextColor) {
        this.addStyle(document.querySelectorAll('.jfProgress-infoContentText'), { color: data.overviewTextColor });
      }

      if (data.progressTextColor) {
        this.addStyle(document.querySelectorAll('.jfProgress-itemLabel'), { color: data.progressTextColor });
      }

      if (data.toggleProgress !== undefined) {
        this.addStyle(document.querySelector('.jfProgress'), { display: data.toggleProgress && 'block'  })
        this.addStyle(document.querySelectorAll('.jfProgress-itemWrapperLine, .jfProgress-itemWrapper'), { display: data.toggleProgress ? 'block' : 'none' });
      }
      if (data.toggleOverview !== undefined) {
        this.addStyle(document.querySelector('.jfProgress'), { display: data.toggleOverview && 'block'})
        this.addStyle(document.querySelector('.jfProgress-infoContent'), { display: data.toggleOverview ? 'inline-block' : 'none' });
        this.addStyle(document.querySelector('.jfProgress-info'), { display: data.toggleOverview ? 'inline-block' : 'none' });
      }

      if (data.toggleLogo !== undefined) {
        const formLogo = document.querySelector('.jfForm-logo')
        if (formLogo) {
          formLogo.style.opacity = data.toggleLogo ? 1 : 0
        }
      }

      if (data.toggleTitle !== undefined) {
        this.addStyle(document.querySelector('.formMode .jfWelcome-header'), { opacity: data.toggleTitle ? 1 : 0 })
      }

      if (data.headerText) {
        this.addStyle(document.querySelectorAll('.jfWelcome-header, .jfWelcome-description'), { color: data.headerText });
      }

      if (data.toggleShadow != undefined) {
        const cssRule = data.toggleShadow ? '0 10px 50px 15px rgba(0, 0, 0, .12)' : '0 0px 0px 0px rgba(0, 0, 0, 0)';
        this.addStyle(document.querySelectorAll('.jfCard, .jfProgress.hackweekProgress > .jfProgress-itemWrapper'), { 'box-shadow': cssRule, '-webkit-box-shadow': cssRule });
      }

      if (data.onlyCard != undefined) {
        const formLogo = document.querySelector('.jfForm-logo')
        if (formLogo) {
          formLogo.style.opacity = data.onlyCard ? 0 : 1
        }
        this.addStyle(document.querySelector('.jfProgress-infoContent'), { display: data.onlyCard ? 'none' : 'inline-block' });
        this.addStyle(document.querySelector('.jfProgress'), { display: data.onlyCard ? 'none' : 'block' })
        this.addStyle(document.querySelector('.jfProgress-itemWrapperLine'), { display: data.onlyCard ? 'none' : 'inline-block' });
        this.addStyle(document.querySelector('.jfProgress-itemWrapper'), { display: data.onlyCard ? 'none' : 'inline-block' });
        this.addStyle(document.querySelector('.jfProgress-info'), { display: data.onlyCard ? 'none' : 'inline-block' });
        const cssRule = data.onlyCard ? '0 0px 0px 0px rgba(0, 0, 0, 0)' : '0 10px 50px 15px rgba(0, 0, 0, .12)';
        this.addStyle(document.querySelectorAll('.jfCard, .jfProgress.hackweekProgress > .jfProgress-itemWrapper'), { 'box-shadow': cssRule, '-webkit-box-shadow': cssRule });
        this.addStyle(document.querySelector('.formMode .jfWelcome-header'), { opacity: data.onlyCard ? 0 : 1 })
      }

      if (data.sizeTitle) {
        this.addStyle(document.querySelector('.jfWelcome-header'), { fontSize: data.sizeTitle });
        this.calculateWelcomeSize();
      }

      if (data.type === 'loadEmbedStyle') {
        this.loadEmbedStyle(data);
      }

      if (data.type === 'requestStorageAccess') {
        this.requestStorageAccess(data);
      }

      if (data.type === 'hasStorageAccess') {
        this.requestStorageAccess(data, false);
      }

      if (data.type === 'InlineEmbedAPIRequest') {
        this.handleInlineEmbedAPIRequest(data);
      }
    } catch (err) {
      console.log('Error on embed options: ', err);
    }
  }

  loadEmbedStyle(data) {
    if (!data.embedUrl) {
      return;
    }

    const embedUrlHash = md5(data.embedUrl);
    if (
      typeof data.embedKeys !== 'object'
      || data.embedKeys.indexOf(embedUrlHash) === -1
    ) {
      return;
    }

    const formcss = document.getElementById('form-css');
    if (!formcss) {
      return;
    }

    const formcssUrl = formcss.getAttribute('href');
    const cdn = formcssUrl.split('stylebuilder')[0];

    const url = `${cdn}stylebuilder-new/${data.formId}/embed/${embedUrlHash}/default.css?embedUrl=${encodeURIComponent(data.embedUrl)}`;
    const link = document.createElement('link');
    link.setAttribute('id', 'form-css');
    link.dataset.embedHash = embedUrlHash;
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('href', url);
    link.addEventListener('load', () => {
      formcss.remove();
    });

    const head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
  }

  handleInlineEmbedAPIRequest(data) {
    const actions = [
      'getEmbedStyles',
      'saveEmbedStyles',
      'resetEmbedStyles'
    ];

    if (!actions.includes(data.action)) return;

    const queryParameters = `?embedUrl=${encodeURIComponent(data.params.embedUrl)}`;
    const baseUrl = `${data.params.baseUrl}inline-embed/${data.params.formId}`;

    const client = apiClient.withBaseUrl(baseUrl);
    const clients = {
      getEmbedStyles: () => client.get(`/styles${queryParameters}`),
      saveEmbedStyles: () => client.post(`/styles${queryParameters}`, data.params.requestBody),
      resetEmbedStyles: () => client.post(`/delete-styles${queryParameters}`, {})
    };

    clients[data.action]()
      .then(response => {
        this.sendPostMessage({
          type: 'InlineEmbedAPIResponse',
          action: data.action,
          response
        });
      })
      .catch(err => {
        this.sendPostMessage({
          type: 'InlineEmbedAPIResponse',
          action: data.action,
          error: err.message
        });
      });
  }

  async requestStorageAccess(data, withButton = true) {
    const callback = () => {
      this.sendPostMessage({ type: 'storageAccessGranted' });
    };

    const callbackDenied = () => {
      this.sendPostMessage({ type: 'storageAccessDenied' });
    };

    if (await this.hasStorageAccess()) {
      return callback();
    }

    if (!withButton) {
      return callbackDenied();
    }

    // Request storage access with a button, a real user interaction is needed
    const button = document.createElement('button');
    button.id = 'storage-access-button';
    button.innerText = 'storage access needed';

    button.addEventListener('click', () => {
      // request storage access
      document.requestStorageAccess().then(
        () => {
          button.remove();
          callback();
        },
        callbackDenied
      );
    });

    document.body.appendChild(button);
  }

  // https://developers.google.com/privacy-sandbox/3pcd/storage-access-api
  async hasStorageAccess() {
    // Check if Storage Access API is supported
    if (!document.requestStorageAccess) {
      // Storage Access API is not supported so best we can do is
      // hope it's an older browser that doesn't block 3P cookies.
      return true;
    }

    // Check if access has already been granted
    if (await document.hasStorageAccess()) {
      return true;
    }

    // Check the storage-access permission
    // Wrap this in a try/catch for browsers that support the
    // Storage Access API but not this permission check
    // (e.g. Safari and older versions of Firefox).
    let permission;
    try {
      permission = await navigator.permissions.query({ name: 'storage-access' });
    } catch (error) {
      // storage-access permission not supported. Assume no cookie access.
      return false;
    }

    if (permission) {
      if (permission.state === 'granted') {
        // Permission has previously been granted so can just call
        // requestStorageAccess() without a user interaction and
        // it will resolve automatically.
        try {
          await document.requestStorageAccess();
          return true;
        } catch (error) {
          // This shouldn't really fail if access is granted, but return false
          // if it does.
          return false;
        }
      } else if (permission.state === 'prompt') {
        // Need to call requestStorageAccess() after a user interaction
        // (potentially with a prompt). Can't do anything further here,
        // so handle this in the click handler.
        return false;
      } else if (permission.state === 'denied') {
        // Currently not used. See:
        // https://github.com/privacycg/storage-access/issues/149
        return false;
      }
    }

    // By default return false, though should really be caught by one of above.
    return false;
  }

  initializeModernProgress() {
    // set only number
    addClass(document.querySelector('.jfProgress'), 'hackweekProgress');
    document.querySelectorAll('.jfProgress-itemLabel').forEach((item) => {
      const dummyItem = item;
      dummyItem.setAttribute('data-hwOldVal', dummyItem.innerHTML);
      dummyItem.innerHTML = parseInt(dummyItem.innerHTML, 10);
    });
  }

  initializeStandardProgress() {
    // set only number
    removeClass(document.querySelector('.jfProgress'), 'hackweekProgress');
    document.querySelectorAll('.jfProgress-itemLabel').forEach((item) => {
      const dummyItem = item;
      dummyItem.innerHTML = dummyItem.getAttribute('data-hwOldVal');
      dummyItem.removeAttribute('data-hwOldVal');
    });

    // i don't know why
    const itemWrapper = document.querySelector('.jfProgress-itemWrapper');
    removeClass(itemWrapper, 'jfProgress-itemWrapper');

    setTimeout(() => {
      addClass(itemWrapper, 'jfProgress-itemWrapper');
    }, 100);
  }

  calculateFormHeight() {
    addClass(document.querySelector('.jfForm-wrapper'), 'hackweekWrapper');

    const welcomeRect = document.getElementById('header_welcomePage').getBoundingClientRect();
    const welcomeSubRect = document.getElementById('subHeader_welcomePage') ? document.getElementById('subHeader_welcomePage').getBoundingClientRect() : { height: 0 };
    const totalWelcome = welcomeSubRect.height > (welcomeRect.height * 2.9) ? (welcomeRect.height * 3.9) : welcomeRect.height + welcomeSubRect.height;
    const progressRect = document.getElementById('cardProgress').getBoundingClientRect();
    const footerHeight = document.querySelector('.formFooter') ? document.querySelector('.formFooter').getBoundingClientRect().height : 0;
    const currentCardFontSizePx = +window.getComputedStyle(window.CardForm.cards[0].cardContainer).fontSize.slice(0, -2);
    const actionHeight = (3.5 * currentCardFontSizePx) + 2;

    let total = totalWelcome + progressRect.height + footerHeight + actionHeight;
    if (this.layout === 'modern') {
      let maxHeight = 0;
      window.CardForm.cards.forEach((card) => {
        if (card.cardContainer.clientHeight > maxHeight) {
          maxHeight = card.cardContainer.clientHeight;
        }
      });
      total += maxHeight;
    } else if (this.layout === 'bouncy') {
      const activeCardHeight = document.querySelector('.jfCard-wrapper.isVisible > .jfCard').getBoundingClientRect().height;
      total += activeCardHeight;
    }

    if (this.layout !== 'standard') {
      document.querySelector('.jfProgress.hackweekProgress').style = '';
    }

    window.parent.postMessage(`setHeight:${total}`, '*');
  }

  handleQuestionChange() {
    document.querySelectorAll('.jfInput-button.forNext, .jfInput-button.forPrev').forEach((button) => {
      button.addEventListener('click', () => {
        if (this.layout === 'bouncy') {
          setTimeout(() => {
            this.calculateFormHeight();
          }, 100);
        }
      });
    });
  }
}
